import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress, } from '@mui/material';
import { Typography } from '../Typography';
export function CircularProgressBar({ progress, variant = 'determinate', color = 'primary', }) {
    return (_jsxs(Box, { sx: { position: 'relative', display: 'inline-flex' }, children: [_jsx(CircularProgress, { title: "progress bar", variant: variant, color: color, value: progress }), _jsx(Box, { sx: {
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }, children: _jsx(Typography, { variant: "caption regular", color: "black", children: `${Math.round(progress)}%` }) })] }));
}
